import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Randomizer from '../components/randomizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeMute } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'gatsby';
import Purchase from '../components/purchase';
import Zoom from 'react-reveal/Zoom'; // Importing Zoom effect

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const OutboundLink = makeShortcode("OutboundLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "the-daughter-of-the-regiment",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#the-daughter-of-the-regiment",
        "aria-label": "the daughter of the regiment permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`The Daughter of the Regiment`}</h1>
    <h2 {...{
      "id": "utah-opera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#utah-opera",
        "aria-label": "utah opera permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Utah Opera`}</h2>
    <blockquote>
      <p parentName="blockquote">{`🔇 We appreciate you silencing your phone.`}</p>
    </blockquote>
    <small>
      <p>{`Content published as of January 9, 2023`}</p>
    </small>
    <Link to="/dutchman" alt="Link to The Daughter of the Regiment" mdxType="Link">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGgAAAgMBAQAAAAAAAAAAAAAAAAQCAwUBBv/EABcBAAMBAAAAAAAAAAAAAAAAAAABAwL/2gAMAwEAAhADEAAAAcGxzqM4mM9ZW5GVFx0eP//EABwQAAICAwEBAAAAAAAAAAAAAAABAxICEBETIv/aAAgBAQABBQIeNdQxO00f1Vjj4LBM8ENdK81//8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/AYJk/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHRAAAgEEAwAAAAAAAAAAAAAAADEQAQIREkFRkf/aAAgBAQAGPwKdq2o7yIQp59j/xAAeEAEAAgEEAwAAAAAAAAAAAAABABExECFRYUFxkf/aAAgBAQABPyELhKm8XGEukwOWFgKTvxO9A8j6myXW86fc+1C6zQ//2gAMAwEAAgADAAAAEIQHsf/EABYRAQEBAAAAAAAAAAAAAAAAABEAAf/aAAgBAwEBPxDMWLANi//EABcRAAMBAAAAAAAAAAAAAAAAAAABESH/2gAIAQIBAT8QbhTSs//EAB4QAQEAAgICAwAAAAAAAAAAAAERACExYRBBUYGh/9oACAEBAAE/EKDYduEeUNiO8iss7wkACxa9dYSmIa4eieO2EHtjUwpYXADB+86jHkND4yahyGOj+eP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/daughter-regiment-2023/static/ef7a469bff3e8dbf3dcd356bdd328c73/8ac56/daughter-regiment-2023.webp 240w", "/daughter-regiment-2023/static/ef7a469bff3e8dbf3dcd356bdd328c73/d3be9/daughter-regiment-2023.webp 480w", "/daughter-regiment-2023/static/ef7a469bff3e8dbf3dcd356bdd328c73/87ca7/daughter-regiment-2023.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/daughter-regiment-2023/static/ef7a469bff3e8dbf3dcd356bdd328c73/09b79/daughter-regiment-2023.jpg 240w", "/daughter-regiment-2023/static/ef7a469bff3e8dbf3dcd356bdd328c73/7cc5e/daughter-regiment-2023.jpg 480w", "/daughter-regiment-2023/static/ef7a469bff3e8dbf3dcd356bdd328c73/1a144/daughter-regiment-2023.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/daughter-regiment-2023/static/ef7a469bff3e8dbf3dcd356bdd328c73/1a144/daughter-regiment-2023.jpg",
              "alt": "The Daughter of the Regiment Cover",
              "title": "The Daughter of the Regiment Cover",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </Link>
    <Purchase mdxType="Purchase" />
    <blockquote>
      <p parentName="blockquote">{`📱 Please use the menu to explore our mobile friendly publication.`}</p>
    </blockquote>
    <Link to="/issuu" mdxType="Link">
      <blockquote>
        <p parentName="blockquote">{`📖 If you prefer a traditional flipbook experience, as with print publications, `}<a parentName="p" {...{
            "href": "/daughter-regiment-2023/issuu"
          }}>{`please click here`}</a>{`.`}</p>
      </blockquote>
    </Link>
    <h3 {...{
      "id": "quick-navigation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#quick-navigation",
        "aria-label": "quick navigation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Quick Navigation`}</h3>
    <div className="home-list">
  <Zoom mdxType="Zoom">
    <Link className="home-column" to="/daughter" mdxType="Link">
      The Daughter of the Regiment
    </Link>
  </Zoom>
  <Zoom mdxType="Zoom">
    <Link className="home-column" to="/cast" mdxType="Link">
      Company / Artistic Team
    </Link>
  </Zoom>
    </div>
    <br />
    {
      /******************ADS ADS ADS******************/
    }
    {
      /******************ADS ADS ADS******************/
    }
    {
      /******************ADS ADS ADS******************/
    }
    <OutboundLink href="https://osher.utah.edu/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEBQP/xAAYAQACAwAAAAAAAAAAAAAAAAACAwABBP/aAAwDAQACEAMQAAAB05JFS2k6B1EhbHoa4WT/xAAeEAACAgICAwAAAAAAAAAAAAABAgADBBIRIhMhI//aAAgBAQABBQLYGW2fQ2ss8gjv1qtq0Yrv3aV4XK7esZS0QEL/AP/EABoRAAICAwAAAAAAAAAAAAAAAAECABEDEFH/2gAIAQMBAT8BFCWnJkQBb1//xAAXEQADAQAAAAAAAAAAAAAAAAAAASEQ/9oACAECAQE/Aay7/8QAHxAAAgIBBAMAAAAAAAAAAAAAAAECESIDEiExEGFx/9oACAEBAAY/AnkbbxKRFLs4rgy79m6OmUoWXN0/E2vhTZ//xAAbEAEAAwEBAQEAAAAAAAAAAAABABEhMUFRYf/aAAgBAQABPyGkFu9ItbDIIx2iz9ijv9ToWlaQIqHvq4rJPNYiNM9yJcvA7RAgPksfVmv2AkL9n//aAAwDAQACAAMAAAAQW+d8/8QAGREAAwADAAAAAAAAAAAAAAAAAAERECFB/9oACAEDAQE/EIND6BoRSY//xAAYEQADAQEAAAAAAAAAAAAAAAAAARExIf/aAAgBAgEBPxDtWJTotKf/xAAeEAEAAgIDAQEBAAAAAAAAAAABABEhMUFRYYGh8P/aAAgBAQABPxADSrY65r9IRYzQAuFV+xCDeOePPIgKwdGw0wro2US1M0nHkN0mfA2LxETrLDQ/DEXvtRL4vVd81LeItL4Be44eAalktcDCWu9/1wabu07n/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/daughter-regiment-2023/static/5af6749032bf105048da332d251487dd/8ac56/u-of-u.webp 240w", "/daughter-regiment-2023/static/5af6749032bf105048da332d251487dd/d3be9/u-of-u.webp 480w", "/daughter-regiment-2023/static/5af6749032bf105048da332d251487dd/87ca7/u-of-u.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/daughter-regiment-2023/static/5af6749032bf105048da332d251487dd/09b79/u-of-u.jpg 240w", "/daughter-regiment-2023/static/5af6749032bf105048da332d251487dd/7cc5e/u-of-u.jpg 480w", "/daughter-regiment-2023/static/5af6749032bf105048da332d251487dd/1a144/u-of-u.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/daughter-regiment-2023/static/5af6749032bf105048da332d251487dd/1a144/u-of-u.jpg",
              "alt": "University of Utah Lifelong Learning",
              "title": "University of Utah Lifelong Learning",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>
    <OutboundLink href="https://www.jerryseinercadillac.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAABAABAwL/xAAXAQADAQAAAAAAAAAAAAAAAAAAAwQC/9oADAMBAAIQAxAAAAHl4XxReORaBaTWRIiwf//EABkQAAMBAQEAAAAAAAAAAAAAAAABEQISEP/aAAgBAQABBQLgeTk6Q9K1Fr1k6ZS+f//EABkRAAIDAQAAAAAAAAAAAAAAAAARAQISQf/aAAgBAwEBPwFx0VRmj//EABcRAQEBAQAAAAAAAAAAAAAAAAEAERD/2gAIAQIBAT8BFteZf//EABYQAQEBAAAAAAAAAAAAAAAAACARMf/aAAgBAQAGPwIQaP/EABwQAAICAgMAAAAAAAAAAAAAAAABEXEhUTFBYf/aAAgBAQABPyFldUhhu0LSLI5+RQlLmxEJ+bI+whUbyf/aAAwDAQACAAMAAAAQB9IN/8QAFxEBAQEBAAAAAAAAAAAAAAAAAAERYf/aAAgBAwEBPxC1Oi7af//EABgRAAIDAAAAAAAAAAAAAAAAAAAQEVFh/9oACAECAQE/EKJgQn//xAAdEAEAAwACAwEAAAAAAAAAAAABABEhMVFBkdGB/9oACAEBAAE/EBtvPyL4ChXZFHiaNAWtSAFiaSxr1DsRZE2Ngqh9pQEbt+oEArOOIAaW979lK3p5fsVSYdXP/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/daughter-regiment-2023/static/b03bb8d1edd271dd8e530b37482e930e/8ac56/jerry-seiner.webp 240w", "/daughter-regiment-2023/static/b03bb8d1edd271dd8e530b37482e930e/d3be9/jerry-seiner.webp 480w", "/daughter-regiment-2023/static/b03bb8d1edd271dd8e530b37482e930e/87ca7/jerry-seiner.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/daughter-regiment-2023/static/b03bb8d1edd271dd8e530b37482e930e/09b79/jerry-seiner.jpg 240w", "/daughter-regiment-2023/static/b03bb8d1edd271dd8e530b37482e930e/7cc5e/jerry-seiner.jpg 480w", "/daughter-regiment-2023/static/b03bb8d1edd271dd8e530b37482e930e/1a144/jerry-seiner.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/daughter-regiment-2023/static/b03bb8d1edd271dd8e530b37482e930e/1a144/jerry-seiner.jpg",
              "alt": "Jerry Seiner Cadillac",
              "title": "Jerry Seiner Cadillac",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      